export enum ROLES_TYPES {
  GET_ROLELIST_REQUEST = '@openClaim/GET_ROLELIST_REQUEST',
  SET_DATA_ROLELIST = '@openClaim/SET_DATA_ROLELIST',
}

export interface RoleState {
  rolesList: string[];
}
